var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor meta-send-capi-event" }, [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.metaCapiContactId"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: _vm.$t("chatbotv2.metaCapiContactIdPh"),
            "show-attributes": true,
            "max-character-count": 100,
          },
          model: {
            value: _vm.clone.contactId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "contactId", $$v)
            },
            expression: "clone.contactId",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.metaCapiEventType"))),
        ]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticClass: "classic-new-select",
            attrs: { placeholder: _vm.$t("chatbotv2.metaCapiSelectEventType") },
            model: {
              value: _vm.clone.eventType,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "eventType", $$v)
              },
              expression: "clone.eventType",
            },
          },
          [
            _c("a-select-option", { attrs: { value: "LeadSubmitted" } }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.metaCapiLeadSubmitted"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "Purchase" } }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.metaCapiPurchase"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "InitiateCheckout" } }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.metaCapiInitiateCheckout"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "AppointmentBooked" } }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.metaCapiAppointmentBooked"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "AddToCart" } }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.metaCapiAddToCart"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "ViewContent" } }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.metaCapiViewContent"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "OrderCreated" } }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.metaCapiOrderCreated"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "OrderShipped" } }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.metaCapiOrderShipped"))),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    ["Purchase", "OrderCreated", "OrderShipped"].includes(_vm.clone.eventType)
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.metaCapiCurrency"))),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: _vm.$t("chatbotv2.metaCapiCurrencyPh"),
                "show-attributes": true,
                "max-character-count": 10,
              },
              model: {
                value: _vm.clone.currency,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "currency", $$v)
                },
                expression: "clone.currency",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    ["Purchase", "OrderCreated", "OrderShipped"].includes(_vm.clone.eventType)
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.metaCapiAmount"))),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: _vm.$t("chatbotv2.metaCapiAmountPh"),
                "show-attributes": true,
                "max-character-count": 50,
              },
              model: {
                value: _vm.clone.value,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "value", $$v)
                },
                expression: "clone.value",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "editor-row" }, [
      _c("div", { staticClass: "editor-row-title" }, [
        _vm._v(_vm._s(_vm.$t("chatbotv2.metaCapiExtraFields"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "custom-data-list" },
        [
          _vm._l(_vm.clone.customData, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "custom-data-item" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: item.key,
                      expression: "item.key",
                    },
                  ],
                  staticClass: "key-input",
                  attrs: { placeholder: _vm.$t("chatbotv2.metaCapiKeyPh") },
                  domProps: { value: item.key },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(item, "key", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("TiptapEditor", {
                  staticClass: "value-input",
                  attrs: {
                    placeholder: _vm.$t("chatbotv2.metaCapiValuePh"),
                    "show-attributes": true,
                    "max-character-count": 200,
                  },
                  model: {
                    value: item.value,
                    callback: function ($$v) {
                      _vm.$set(item, "value", $$v)
                    },
                    expression: "item.value",
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "remove-btn",
                    on: {
                      click: function ($event) {
                        return _vm.removeCustomData(index)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("delete"),
                    ]),
                  ]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "add-btn", on: { click: _vm.addCustomData } },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("chatbotv2.metaCapiAddField")) +
                  "\n            "
              ),
            ]
          ),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "info-box" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("chatbotv2.metaCapiInfo")) +
            "\n        "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }